import { render, staticRenderFns } from "./form-dynamic-tree-select.vue?vue&type=template&id=406bc00b&scoped=true"
import script from "./form-dynamic-tree-select.ts?vue&type=script&lang=ts&external"
export * from "./form-dynamic-tree-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bc00b",
  null
  
)

export default component.exports